export default __webpack_public_path__ + "images/38e3c2f39df0697a1058afc9666a657c-menu-attention.svg";